import { FC } from 'react';

import { OrderLineDetail } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

import { OrderPriceInfoRow } from '../../order/order-price-info-row';

interface Props {
   orderLine: OrderLineDetail;
   canViewPrices: boolean;
}

export const OrderLineDetailsTable: FC<Props> = ({ orderLine, canViewPrices }: Props) => {
   const translate = useTranslations();
   const format = useFormatter();

   return (
      <Box direction="column">
         <Table stroked="horizontal" hover={false} rowDividers={false}>
            <TableBody>
               <TableRow>
                  <TableCell>
                     <Typography variant="small-highlight" color="primary">
                        {translate('page-consumer.order-line-flyout.your-order-reference')}
                     </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="small">{orderLine.customerOrderReference || '-'}</Typography>
                  </TableCell>
               </TableRow>
               <TableRow>
                  <TableCell>
                     <Typography variant="small-highlight" color="primary">
                        {translate('page-consumer.order-line-flyout.quantity')}
                     </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="small">{format.quantity(orderLine.quantity)}</Typography>
                  </TableCell>
               </TableRow>
               <TableRow>
                  <TableCell>
                     <Typography variant="small-highlight" color="primary">
                        {translate('page-consumer.order-line-flyout.packaging')}
                     </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="small">{orderLine.packaging}</Typography>
                  </TableCell>
               </TableRow>
               <TableRow>
                  <TableCell>
                     <Typography variant="small-highlight" color="primary">
                        {translate('page-consumer.order-line-flyout.colour')}
                     </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="small">{translate(`colors.${orderLine.product.color.toLowerCase().replace(' ', '-')}`)}</Typography>
                  </TableCell>
               </TableRow>
               <TableRow>
                  <TableCell>
                     <Typography variant="small-highlight" color="primary">
                        {translate('page-consumer.order-line-flyout.colour-code')}
                     </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="small">{orderLine.product.producerColor}</Typography>
                  </TableCell>
               </TableRow>
               <OrderPriceInfoRow
                  unitPrice={orderLine.unitPrice}
                  isUnitPriceFixed={orderLine.isUnitPriceFixed ?? true}
                  canViewPrices={canViewPrices}
               />
            </TableBody>
         </Table>
      </Box>
   );
};
